var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-snackbar",
        {
          attrs: {
            color: "green",
            bottom: "",
            "min-width": _vm.$vuetify.breakpoint.width < 800 ? "90vw" : null
          },
          model: {
            value: _vm.successTransfer,
            callback: function($$v) {
              _vm.successTransfer = $$v
            },
            expression: "successTransfer"
          }
        },
        [
          _c("v-icon", [_vm._v("mdi-check")]),
          _c("span", [_vm._v("Rack Successfully transfered")])
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { justify: "center" } },
        [
          _vm.restrictedAccess(6)
            ? _c(
                "v-col",
                { attrs: { lg: "3", md: "5", cols: "12" } },
                [
                  _c("create-incubator", {
                    attrs: { "default-data": _vm.editIncubator },
                    on: {
                      "update:defaultData": function($event) {
                        _vm.editIncubator = $event
                      },
                      "update:default-data": function($event) {
                        _vm.editIncubator = $event
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "v-col",
            { attrs: { lg: "7", md: "7", cols: "12" } },
            [
              _c("table-incubator", {
                attrs: { edit: _vm.editIncubator },
                on: {
                  "update:edit": function($event) {
                    _vm.editIncubator = $event
                  },
                  transfer: item => (_vm.incubatorRack = item)
                }
              })
            ],
            1
          ),
          _c("transfer-eggs", {
            on: {
              success: function($event) {
                _vm.successTransfer = true
              }
            },
            model: {
              value: _vm.incubatorRack,
              callback: function($$v) {
                _vm.incubatorRack = $$v
              },
              expression: "incubatorRack"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }